import { useRef, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import Select from "react-select";
import { QRCodeSVG } from "qrcode.react";
import logo from "../../../../../images/logo.svg";

const LeaveModal = ({ modal, setModal, item, setShouldUpdate, Service }) => {
	const [qrCode, setQrCode] = useState("");
	const qrRef = useRef();
	const [type, setType] = useState("");
	const [loading, setLoading] = useState(false);
	const typesOptions = [
		{ label: "Knet", value: "knet" },
		{ label: "CC", value: "cc" },
		{ label: "Samsung Pay", value: "samsung-pay" },
		{ label: "Apple Pay", value: "apple-pay" },
		{ label: "Google Pay", value: "google-pay" },
		{ label: "Cash", value: "cash" },
	];
	const lang = useSelector((state) => state.auth.lang);

	const submit = (e) => {
		e.preventDefault();
		if (!type) {
			toast.error("Select Payment Type");
			return;
		}
		let data = {
			paymentType: type?.value,
		};

		setLoading(true);
		Service.pay(item?.id, data)
			?.then((res) => {
				if (res && res?.status === 200) {
					if (type?.value !== "cash") {
						setQrCode(res?.data?.data);
					} else {
						setShouldUpdate((prev) => !prev);
						setModal();
					}
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	const print = () => {
		const svg = qrRef.current.querySelector("svg");
		const svgData = new XMLSerializer().serializeToString(svg);
		const imgData = "data:image/svg+xml;base64," + btoa(svgData);
		const printWindow = window.open("", "_blank");

		let htmlCode = `
			<html>
				<head>
					<meta charset="UTF-8">
					<meta name="viewport" content="width=device-width, initial-scale=1.0">
					<title>Payment</title>
				</head>
				<body style="margin: 0; padding: 0">
				<div style="margin-top: .5rem; padding: 0 4rem;">
				<img src="${logo}" style="width:130px;height:130px;" />

				</div>
					<div style="text-align: center; margin-top: 2.5rem">
						<img src="${imgData}" style="width:400px;height:400px" />
					</div>
				</body>
			</html>
		`;
		printWindow.document.write(htmlCode);
		printWindow.document.close();

		setTimeout(() => {
			printWindow.print();
		}, 1500);
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addQuick" : "ar fade addQuick"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={modal}
			onHide={() => {
				setModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{Translate[lang]?.leave}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						{!qrCode && (
							<Col md={12} className="mt-3">
								<label className="text-label">
									{Translate[lang]?.payment_type}
								</label>
								<Select
									value={type}
									name="payment_type"
									placeholder={Translate[lang]?.select}
									options={typesOptions}
									onChange={(e) => setType(e)}
								/>
							</Col>
						)}
						{!!qrCode && (
							<Col md={12} className="mt-3">
								<label className="text-label d-block mb-3">Scan to Pay</label>
								<div className="text-center" ref={qrRef}>
									<img
										src={logo}
										alt="logo"
										className="d-block m-auto"
										width={120}
										height={80}
									/>
									<QRCodeSVG value={qrCode} size={250} renderAs="canvas" />
								</div>
							</Col>
						)}
					</Row>
				</Modal.Body>
				<Modal.Footer>
					{!qrCode && (
						<Button
							variant="primary"
							type="submit"
							className="w-100"
							disabled={loading}>
							{Translate[lang]?.pay}
						</Button>
					)}
					{!!qrCode && (
						<div
							className="w-100 d-flex justify-content-between"
							style={{ gap: "24px" }}>
							<Button
								variant="danger"
								onClick={() => {
									setShouldUpdate((prev) => !prev);
									setModal();
								}}
								type="button"
								className="w-100"
								disabled={loading}>
								{Translate[lang]?.close}
							</Button>
							<Button
								variant="primary"
								onClick={() => print()}
								type="button"
								className="w-100"
								disabled={loading}>
								{Translate[lang]?.print}
							</Button>
						</div>
					)}
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default LeaveModal;
